import { render } from "./_Payout.vue?vue&type=template&id=2f47feb0"
import script from "./_Payout.vue?vue&type=script&lang=js"
export * from "./_Payout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__